// Upsell de personalizacion de alfombras en el cart drawer.
// v9: misma secuencia probada como funcional (quitar linea vieja -> esperar
// -> anadir personalizada -> avisar al carrito), PERO ahora se cubre el
// carrito con una cortina de carga durante la transicion, para que el
// cliente nunca vea el estado intermedio de "carrito vacio".
(function () {
  console.log('[cart-rug-upsell] script cargado v9');

  var DISMISS_KEY = 'mt-rug-upsell-dismissed';

  function ensureJsSuffix(url) {
    return url.replace(/\.js$/, '') + '.js';
  }

  function keepDialogFocused(root) {
    var dialog = root.closest('dialog');
    if (dialog && typeof dialog.focus === 'function') {
      dialog.focus();
    }
  }

  function showOverlay(root) {
    var dialog = root.closest('dialog');
    if (!dialog) return null;

    var overlay = document.createElement('div');
    overlay.className = 'cart-rug-upsell-overlay';
    overlay.innerHTML =
      '<div class="cart-rug-upsell-overlay__spinner">' +
      '<span></span><span></span><span></span>' +
      '</div>';
    dialog.appendChild(overlay);
    return overlay;
  }

  function hideOverlay(overlay) {
    if (overlay && overlay.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }
  }

  function handleClose(closeBtn) {
    var root = closeBtn.closest('[data-cart-rug-upsell]');
    if (!root) return;

    try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}

    keepDialogFocused(root);
    root.remove();
  }

  function findRemoveButton(line) {
    var selector = '[on\\:click="/onLineItemRemove/' + line + '"]';
    return document.querySelector(selector);
  }

  function notifyCartUpdated(cartJson) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cartJson,
          sourceId: 'cart-rug-upsell',
          data: { source: 'cart-rug-upsell', itemCount: cartJson.item_count }
        }
      })
    );
  }

  function handleSubmit(button) {
    console.log('[cart-rug-upsell] click detectado');

    var root = button.closest('[data-cart-rug-upsell]');
    if (!root) return;

    var nameInput = root.querySelector('[data-upsell-name]');
    var colorSelect = root.querySelector('[data-upsell-color]');
    if (!nameInput || !colorSelect) return;

    var name = nameInput.value.trim();
    var color = colorSelect.value;

    if (name === '') {
      alert(button.dataset.nameError);
      nameInput.focus();
      return;
    }
    if (color === '') {
      alert(button.dataset.colorError);
      colorSelect.focus();
      return;
    }

    var line = parseInt(root.dataset.line, 10);
    var variantId = parseInt(root.dataset.personalizedVariantId, 10);
    var quantity = parseInt(root.dataset.quantity, 10) || 1;

    console.log('[cart-rug-upsell] datos:', { line: line, variantId: variantId, quantity: quantity, name: name, color: color });

    var removeBtn = findRemoveButton(line);
    console.log('[cart-rug-upsell] boton de papelera encontrado?', !!removeBtn);

    var originalText = button.dataset.buttonLabel;

    keepDialogFocused(root);
    button.disabled = true;
    button.textContent = '...';

    var overlay = showOverlay(root);

    var properties = {};
    properties[button.dataset.propertyNameLabel] = name;
    properties[button.dataset.propertyColorLabel] = color;

    var addUrl = ensureJsSuffix(
      (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js'
    );

    function doAdd() {
      console.log('[cart-rug-upsell] anadiendo variante personalizada...');
      return fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: quantity, properties: properties }]
        })
      }).then(function (res) {
        console.log('[cart-rug-upsell] respuesta de add.js, status:', res.status);
        if (!res.ok) {
          return res.json().then(function (e) {
            throw new Error((e && e.description) || 'add failed');
          });
        }
        return res.json();
      });
    }

    function fail(err) {
      console.error('[cart-rug-upsell] ERROR FINAL:', err);
      hideOverlay(overlay);
      alert(button.dataset.genericError);
      button.disabled = false;
      button.textContent = originalText;
    }

    function afterBoth() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cartJson) {
          console.log('[cart-rug-upsell] TODO OK. Avisando al carrito para que se refresque solo (sin recargar).');
          try { sessionStorage.setItem(DISMISS_KEY, '1'); } catch (e) {}
          notifyCartUpdated(cartJson);
          button.textContent = originalText;
          button.disabled = false;
          hideOverlay(overlay);
        });
    }

    if (removeBtn) {
      console.log('[cart-rug-upsell] pulsando el boton de papelera nativo...');
      removeBtn.click();

      setTimeout(function () {
        keepDialogFocused(root);
        doAdd().then(afterBoth).catch(fail);
      }, 1200);
    } else {
      doAdd().then(afterBoth).catch(fail);
    }
  }

  document.addEventListener('click', function (event) {
    var closeBtn = event.target.closest('[data-upsell-close]');
    if (closeBtn) {
      handleClose(closeBtn);
      return;
    }

    var submitBtn = event.target.closest('[data-upsell-submit]');
    if (submitBtn) {
      handleSubmit(submitBtn);
    }
  });
})();
